<template>
  
  <el-dialog  v-if="dialogVisible" width="68%"   :visible.sync="dialogVisible" @close="qx()"  :title="examine ? '修改': '查看' " :close-on-click-modal="false" :close-on-press-escape="false">
<div id="lo">
    <el-form :model="dataForm"   :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '150px' : '150px'">
      <div v-if="dataForm.borrowerType == 'PERSONAGE'">
        <h3 class='h3'>借款人</h3>
        <div class="line-box">
          <el-form-item label="姓名"  class="styW">
            <el-input v-model="dataForm.custName" disabled placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号"  class="styW">
              <el-input v-model="dataForm.mobile" disabled placeholder="手机号" ></el-input>
          </el-form-item>
          <el-form-item label="身份证号码"  class="styW">
            <el-input v-model="dataForm.idNo" disabled placeholder="证件号码"></el-input>
          </el-form-item>
          <el-form-item label="邮箱地址" class="styW1">
            <el-input v-model="dataForm.email" disabled  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="现住地址"  class="sandh">
            <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="examine" label="添加共借人">
          <el-button @click="gjr = true">添加共借人</el-button>
        </el-form-item>
        <!-- 共借人添加 -->
        <el-card v-if="gjr">
          <el-form :model="relationList" :rules="rules"
          :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
          ref="relationList" >
            <div class="line-box">
              <el-form-item label="姓名" prop="name"  class="styW">
                <el-input v-model="relationList.name"  placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile"  class="styW">
                <el-input v-model="relationList.mobile"  placeholder="手机号" ></el-input>
              </el-form-item>
              <el-form-item label="身份证号码" prop="idNo"  class="styW">
                <el-input v-model="relationList.idNo"  placeholder="证件号码"></el-input>
              </el-form-item>
              <el-form-item label="地址/住址" prop="addr"  class="styW">
                <el-input v-model="relationList.addr"  placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="邮箱地址" prop="email"  class="styW">
                <el-input v-model="relationList.email" placeholder="请输入"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="操作" >
              <el-button @click="gjr = false">取消</el-button>
              <el-button @click="submitForm('relationList')" >添加</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <h3 class='h3' v-if="dataForm.relationList.length > 0">共借人</h3>
        <div class="line-box">
          <div class="line-box">
            <div class="gjr" v-for="(item,index) in dataForm.relationList" :key="item.idNo" >
              <el-form-item class="styW" label="姓名" :prop="'relationList.' + index + '.name'" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文', trigger: 'blur' }">
                <el-input v-model="item.name" :disabled="!examine"  placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item class="styW" label="Tel" :prop="'relationList.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
                <el-input v-model="item.mobile" :disabled="!examine"  placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item class="styW" label="身份证号码" :prop="'relationList.' + index + '.idNo'" :rules="{ required: true,  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }">
                <el-input  v-model="item.idNo"  :disabled="!examine" placeholder="证件号码"></el-input>
              </el-form-item>
              <el-form-item class="styW" label="地址/住址" :prop="'relationList.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
                <el-input v-model="item.addr" :disabled="!examine"  placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item  class="styW" label="邮箱地址" :prop="'relationList.' + index + '.email'" :rules="{ required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }">
                <el-input v-model="item.email" :disabled="!examine"  placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item v-if="examine" class="styW" label="是否删除共借人" >
                <el-button @click="del(item.mobile)">删除</el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dataForm.borrowerType == 'ENTERPRISE'">
        <h3 class="h3">借款企业</h3>
        <div class="line-box">
          <el-form-item label="企业名称"   class="styW">
              <el-input v-model="dataForm.custName" disabled placeholder="企业名称"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码"  class="styW">
            <el-input v-model="dataForm.idNo" disabled placeholder="统一社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="联系电话"  class="styW">
            <el-input v-model="dataForm.mobile" disabled placeholder="联系电话" ></el-input>
          </el-form-item> 
        </div>
        <div class="line-box">
          <el-form-item class="styW" label="收款银行账号" >
            <el-input  v-model="dataForm.bankCardNo" disabled placeholder="收款银行账号"></el-input>
          </el-form-item>
          <el-form-item  style="width:500px" label="银行名称">
            <el-input  v-model="dataForm.bankName" disabled placeholder="银行名称"></el-input>
          </el-form-item>
        </div>
        <div class="line-box">
          <el-form-item label="开户行所在省"  class="styW">
            <el-input v-model="dataForm.bankProName" disabled  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item el-form-item label="所在市"  class="styW">
            <el-input v-model="dataForm.bankCityName" disabled  placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="开户支行名称"  style="width:500px" >
            <el-input v-model="dataForm.brabankName" disabled  placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址"  style="width:500px" >
            <el-input v-model="dataForm.email" disabled  placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="现住地址"   class="sandh">
            <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
        </el-form-item>
        <h3 class='h3' v-if="dataForm.relationList.length > 0">共借企业</h3>
        <div class="line-box">

<div class="line-box">
 <div class="gjr" v-for="(item,index) in dataForm.relationList" :key="item.idNo" >
     <el-form-item class="styW" label="企业名称" :prop="'relationList.' + index + '.name'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
       <el-input v-model="item.name" disabled  placeholder="企业名称"></el-input>
     </el-form-item>
     <el-form-item class="styW" label="联系电话" :prop="'relationList.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
         <el-input v-model="item.mobile" disabled placeholder="联系电话"></el-input>
     </el-form-item>
     <el-form-item class="styW" label="统一社会信用代码" :prop="'relationList.' + index + '.idNo'" :rules="{ required: true,  pattern: /^(?:\d{6}(?:\d{8}(?:\d|X|x)?|((0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}))|[A-Z0-9]{18})$/, message: '请输入正确的证件号', trigger: 'blur' }">
         <el-input  v-model="item.idNo"  disabled placeholder="统一社会信用代码"></el-input>
       </el-form-item>
     <el-form-item class="styW" label="地址/住址"  :prop="'relationList.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
         <el-input v-model="item.addr" disabled placeholder="请输入"></el-input>
     </el-form-item>
     <el-form-item  class="styW" label="邮箱地址" :prop="'relationList.' + index + '.email'" :rules="{ required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }">
         <el-input v-model="item.email" disabled placeholder="请输入"></el-input>
     </el-form-item>
     <el-form-item class="styW" label="是否删除共借人" >
       <el-button @click="del(item.mobile)">删除</el-button>
     </el-form-item>
   </div>
 </div>
 </div>
      </div>
    <h3 class="h3">借款信息</h3>
    <div class="line-box">
      <el-form-item class="styW" label="借款产品" prop="loanApplyList[0].productCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
        <el-select class="sandh"  v-model="dataForm.loanApplyList[0].productCode" :disabled="!examine"  clearable placeholder="请选择"  @change="echo(dataForm.borrowValue)">
          <el-option
            v-for="item in borrowType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
        
      <!-- <el-form-item v-if="isShowPledge" class="styW" label="贷款种类" prop="loanType" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.loanType" :disabled="!examine" clearable placeholder="请选择" >
          <el-option
            v-for="item in loanTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item v-if="isShowPledge" class="sandh" label="贷款详细用途" prop="loanApplyList[0].loanUsage" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.loanApplyList[0].loanUsage" :disabled="!examine" clearable placeholder="请选择" >
          <el-option
            v-for="item in loanDetailed"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item v-if="isShowPledge" class="styW" label="还款方式" prop="repaymentTypeCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.repaymentTypeCode" :disabled="!examine" clearable placeholder="请选择" >
          <el-option
            v-for="item in repaymentTypeCode"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item  class="styW" label="还款付息方式" prop="loanApplyList[0].interestTypeCode" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select class="sandh" v-model="dataForm.loanApplyList[0].interestTypeCode" :disabled="!examine" placeholder="请输入">
          <el-option
            v-for="(item,index) in repaymentMode"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  class="styW" label="放款回单付款用途" prop="loanApplyList[0].postScript" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-select class="sandh" v-model="dataForm.loanApplyList[0].postScript" :disabled="!examine" placeholder="请输入">
            <el-option
              v-for="(item,index) in receiptList"
              :key="index"
              :label="item.label"
             :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
      <el-form-item  class="styW" label="借款用途" prop="loanApplyList[0].loanUsage" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '只能为中文' }">
          <el-input v-model="dataForm.loanApplyList[0].loanUsage" :disabled="!examine" placeholder="请输入"></el-input>
      </el-form-item>
      
      <el-form-item    style="width: 500px;" label="借款期限" prop="loanApplyList[0].initPeriod" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
       <el-date-picker
                    v-model="dataForm.loanApplyList[0].initPeriod"
                    :disabled="!examine"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    >
            </el-date-picker>
      </el-form-item>

      <el-form-item class="styW" label="借款利率" prop="loanApplyList[0].loanRate" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <el-input-number  v-model="dataForm.loanApplyList[0].loanRate" :disabled="!examine" :precision="2" :min="0" :step="0.1" :max="24"></el-input-number>
          <span>  %<span class="font-max">/</span>{{  isShowPledge ? '年' : '年'}}  </span>   
      </el-form-item>
      <el-form-item v-if="!isShowPledge" class="styW" label="结息方式" prop="loanApplyList[0].interestTypeCode" :rules="{ required: true,pattern: /^[\u4E00-\u9FA5]+$/, message: '输入中文', trigger: 'blur' }">
          <el-input v-model="dataForm.loanApplyList[0].interestTypeCode" :disabled="!examine" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item  class="styW" label="借款金额" prop="loanApplyList[0].loanAmount" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <el-input @blur="changeAmount" style="width:85%" v-model="dataForm.loanApplyList[0].loanAmount" :disabled="!examine"    ></el-input>
           元
      </el-form-item>
      <!-- <el-form-item class="styW" label="逾期利率" prop="loanApplyList[0].overdueRate" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }" >
        <el-input-number class="sandh" v-model="dataForm.loanApplyList[0].overdueRate" :disabled="!examine" :precision="2" :min="0" :step="0.1" :max="200"></el-input-number>
       </el-form-item> -->

      <el-form-item class="sandh" label="合同数量" prop="registerProvinceCode">
       
        <div  class="ht">
          <div>合同共 {{dataForm.relationList.length + (isShowPledge ? 4 : 2) }} 份</div>
          <div>甲方 {{isShowPledge ? '1' : dataForm.relationList.length + 1}} 份 乙方 {{!isShowPledge ? '1' : dataForm.relationList.length + 1}} 份 </div>
          <div v-if="isShowPledge">
            公证处、房屋登记机构各执1份
          </div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </el-form-item>

      <el-form-item class="styW" label="合同签订日期" prop="loanApplyList[0].createTime" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
        <el-date-picker
            v-model="dataForm.loanApplyList[0].createTime"
            :disabled="!examine"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
      </el-form-item>
      
      <el-form-item class="styW" label="银行卡号" prop="loanApplyList[0].bankCardNo" :rules="{ required: true, message: '请输入银行卡号',min: 12, max: 20, trigger: 'blur', }">
          <el-input type="number" v-model="dataForm.loanApplyList[0].bankCardNo" :disabled="!examine" placeholder="银行卡号"></el-input>
      </el-form-item>
      <el-form-item style="width:500px" label="银行名称" prop="loanApplyList[0].bankName" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
        <el-select  class="sandh" v-model="dataForm.loanApplyList[0].bankName" :disabled="!examine"  filterable  clearable placeholder="请选择"  @change="echo(dataForm.borrowValue)">
          <el-option
            v-for="(item,index) in llBank"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="styW" label="解决争议方式" prop="loanApplyList[0].disputeMode" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
        <el-select  class="sandh" v-model="dataForm.loanApplyList[0].disputeMode" :disabled="!examine"  filterable  clearable placeholder="请选择">
          <el-option
            v-for="(item,index) in disputeMode"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="dataForm.loanApplyList[0].disputeMode == '2'" class="styW" label="仲裁委" prop="loanApplyList[0].arbitrationCommittee" :rules="{ required: true,message: $t('validate.required'),trigger: 'blur' }">
        <div  class="arbitration">
          <el-input class="ar_input" v-model="dataForm.loanApplyList[0].arbitrationCommittee" :disabled="!examine" placeholder="请输入"></el-input>
          <span>仲裁委员会</span>
        </div>
         
      </el-form-item>
      <div style="width:100%; display: flex;align-items: center;"> 
        <el-form-item label="借款合同签订地"></el-form-item>
        <el-form-item style="position: relative;" label="" prop="loanSheng"  label-width="0px">
          <div class="selectArea">*</div>
          <el-select @change="selectCity" class="sandh" :disabled="!examine" v-model="dataForm.loanSheng" filterable clearable placeholder="请选择省">
            <el-option
              v-for="(item,index) in shengList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="position: relative;"   label="" prop="loanShi"  label-width="10px">
          <div class="selectArea">*</div>
          <el-select @change="selectCity" class="sandh" :disabled="!examine" v-model="dataForm.loanShi" clearable filterable placeholder="请选择市">
            <el-option
              v-for="(item,index) in shiList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item   prop="loanQu" label-width="10px" >
          <el-select @change="selectCity" class="sandh" :disabled="!examine" v-model="dataForm.loanQu" clearable filterable placeholder="请选择区">
            <el-option
              v-for="(item,index) in quList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0px">
          （区根据需要选填）
        </el-form-item>
     </div>
    </div>
    <h3 class="h3" v-if="isShowPledge">抵押信息</h3>
    <div class="line-box" v-if="isShowPledge">
      <el-form-item label="抵押人"   class="styW">
          <el-input v-model="dataForm.custName" disabled placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码"  class="styW">
          <el-input v-model="dataForm.idNo" disabled placeholder="证件号码"></el-input>
      </el-form-item>
      <el-form-item label="联系电话"  class="styW">
          <el-input v-model="dataForm.mobile" disabled placeholder="手机号" ></el-input>
      </el-form-item>     
    </div>
    <div class="line-box" v-if="isShowPledge">
      <el-form-item label="通讯地址" class="sandh">
          <el-input v-model="dataForm.address" disabled placeholder="请输入"></el-input>
      </el-form-item>
    </div>
    <div v-if="isShowPledge">
      <div v-for="(item,index) in dataForm.commonMortgage" :key="index">
        <div class="line-box">
          <el-form-item :label="'抵押人'+ (index+2)*1"   class="styW" :prop="'commonMortgage.' + index + '.name'" :rules="{ required: true, pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文', trigger: 'blur' }">
            <el-input v-model="item.name" disabled placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码"  class="styW" :prop="'commonMortgage.' + index + '.idNo'" :rules="{ required: true,  pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }">
            <el-input v-model="item.idNo" disabled placeholder="证件号码"></el-input>
          </el-form-item>
          <el-form-item label="联系电话"  class="styW" :prop="'commonMortgage.' + index + '.mobile'" :rules="{required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur'}">
            <el-input v-model="item.mobile" :disabled="!examine" placeholder="手机号" ></el-input>
          </el-form-item> 
        </div>
        <div class="line-box">
          <el-form-item label="通讯地址" class="sandh" :prop="'commonMortgage.' + index + '.addr'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
            <el-input v-model="item.addr" :disabled="!examine"  placeholder="请输入"></el-input>
          </el-form-item>
        </div>
          
      </div>
    </div>
    <div class="line-box" v-if="isShowPledge">
      <el-form-item class="sandh" label="抵押物产权证号" prop="mortgageNo"  :rules="{ required: true,message: '不能为空' }">
        <el-input v-model="dataForm.mortgageNo" :disabled="!examine" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item class="sandh" label="抵押物坐落" prop="mortgageAddress" :rules="{ required: true,message: '不能为空' }">
          <el-input v-model="dataForm.mortgageAddress" :disabled="!examine" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="建筑面积(㎡)" prop="buildArea"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input-number class="sandh" v-model="dataForm.buildArea" :disabled="!examine" :min="0"  ></el-input-number>
      </el-form-item>
      <el-form-item label="评估价值(万元)" prop="price"  class="styW" :rules="{ required: true,message: '不能为空' }">
        <el-input-number class="sandh" v-model="dataForm.price" :disabled="!examine" :min="0"  ></el-input-number>
      </el-form-item>
      <el-form-item  class="styW" label="使用现状" prop="useCurrentSituation" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-select style="width: 270px;" class="sandh" :disabled="!examine" v-model="dataForm.useCurrentSituation" placeholder="请选择" clearable filterable>
          <el-option
            v-for="(item,index) in useStatusList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>       
      </el-form-item>
    </div>
    <div class="line-box" v-if="isShowPledge">
      <div style="width:100%; display: flex;"> 
        <el-form-item  label="签署地" prop="sheng" >
          <el-select class="sandh" v-model="dataForm.sheng" :disabled="!examine" filterable clearable placeholder="请选择">
            <el-option
              v-for="(item,index) in city"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="" prop="shi" label-width="10px" >
          <el-select  v-model="dataForm.shi" :disabled="!examine" clearable filterable placeholder="请选择">
            <el-option
              v-for="(item,index) in cityList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
     </div>


      <!-- <el-form-item label="土地使用权面积(平方米)" label-width="171px"   class="styW" >
       
        <el-input-number class="sandh" v-model="dataForm.useArea" :disabled="!examine" :min="0"  ></el-input-number>
      </el-form-item> -->

      
      
      
      <!-- <el-form-item  class="sandh" label="抵押物其他详情"  >
        <el-input  v-model="dataForm.mortgageAtt" :disabled="!examine"  placeholder="" ></el-input>
      </el-form-item> -->
   
    </div>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ examine ? $t('cancel') : '关闭' }}</el-button>
      <el-button v-if="examine" type="primary" @click="dataFormSubmitHandle()" :disabled="isButton">{{ $t('confirm') }}</el-button>
    </template>
  </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { arrCity } from '../../../utils/city'

export default {
  created(){
    arrCity.forEach(item => {
      this.city.push(...item.city.map(item => item))
      this.shengList.push(item.name)
      
    })
    this.$loading({
        target: '.el-dialog'
      });
    arrCity.forEach(item => {
      this.city.push(...item.city.map(item => item))
    })
    this.$http.get(`/sys/dict/data/list?dataType=interestTypeCode`).then(r=>{
      this.interestTypeCode = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      console.log( r.data.data )
    })
    this.$http.get(`/sys/dict/data/list?dataType=disputeMode`).then(r=>{
      this.disputeMode = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=repaymentMode`).then(r=>{
      this.repaymentMode = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=receipt_purpose`).then(r=>{
      this.receiptList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
     
    })
    this.$http.get(`/sys/dict/data/list?dataType=loanTypes`).then(r=>{
      this.loanTypes = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      console.log( r.data.data )
    })
    this.$http.get(`/sys/dict/data/list?dataType=loanDetailed`).then(r=>{
      this.loanDetailed = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      console.log( r.data.data )
    })
    this.$http.get(`/sys/dict/data/list?dataType=repaymentTypeCode`).then(r=>{
      this.repaymentTypeCode = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      console.log( r.data.data )
    })

    this.$http.get(`/sys/dict/data/list?dataType=llBank`).then(r=>{
      this.llBank = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    })
   
    this.$http.get('/loan/tproduct/page',{
      page: 1,
      limit: 1000,
    }).then(r => {
      this.borrowType = r.data.data.list.map(item => ({value:item.productCode,label:item.productName
      }))
      console.log(r.data.data.list)
    })
    
  },
  data () {
    return {
      shengList:[],
      shiList:[],
      quList:[],
      examine:false,
      isButton:false,
      isShowPledge:true,
      llBank:[],
      disputeMode:[],
      repaymentMode:[],
      receiptList:[],
      infoid:'',
      visible: false,
      dialogVisible:false,
      date:'',
      city:[],
      gjr:false,
      borrowType:[],
      interestTypeCode:[],
      loanTypes:[],
      repaymentTypeCode:[],
      loanDetailed:[],
      useStatusList:[
        { value:'自住',label:'自住' },
        { value:'空置',label:'空置' },
        { value:'租赁',label:'租赁' },
      ],
     
      // 共借人
      relationList:{
        "addr": "",
        "email": "",
        "idNo": "",
        "mobile": "",
        "name": "",
      },
      commonMortgage:{
        "addr": "",
        "idNo": "",
        "mobile": "",
        "name": "",
      },
      dataForm: {
        loanSheng:"",
        loanShi:"",
        loanQu:"",
        "address": "",
        "areaCode": "",
        "cityCode": "",
        "custName": "",
        email:'',
        "id": '',
        "idNo": "",
        loanType:'',
        loanDetailed:'',
        repaymentTypeCode:'',
        mortgageAddress:'',
        buildArea:'',
        useArea:'',
        mortgageNo:'',
        price:'0',
        useCurrentSituation:'',
        signAddress:'',
        mortgageAtt:'',
        sheng:'',
        shi:'',
        "loanApplyList": [
        {
                  "bankCardNo": "",
                   bankName:'',
                  "createTime": "",
                  "disputeMode": "",
                  "arbitrationCommittee": "",
                  "custId": '',
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "postScript":'',
                  "loanAmount": '',
                  "loanRate": '',
                  "loanUsage": "",
                  "overdueRate": '',
                  "productCode": "",
                  "signPlace": "",

                }
        ],
        "mobile": "",
        "provinceCode": "",
        "registerAddress": "",
        "registerAreaCode": "",
        "registerCityCode": "",
        "registerProvinceCode": "",
        "relationList": [
        ],
        "commonMortgage":[]
	    },
      rules: {
          name: [
          {required: true,message: '请输入用户名',trigger: 'blur'},{min: 2,max: 8,message: '长度在 2 到 8 个字符'},{pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文'}
           
          ],
          mobile: [
            { required: true, message: '请输入电话号码', trigger: 'blur' },
            { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的电话号码', trigger: 'blur' }
          ],
          idNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 15, max: 18, message: '请如实填写身份证号', trigger: 'blur' },
                {
                    required: true,
                    pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                    message: '请输入正确的身份证号码',
                    trigger: 'blur'
                }
           
          ],
        
          addr: [
            {required: true,message: '请输入地址',trigger: 'blur'}
          ],
          email: [
            { required: true,type:'email', message: '请输入正确的邮箱', trigger: 'blur' }
          ],
         
        },
      
    }
  },
  computed: {
    
    dataRule () {
      return {
        custCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        custName: [
          {required: true,message: '请输入用户名',trigger: 'blur'},{min: 2,max: 8,message: '长度在 2 到 8 个字符'},{pattern: /^[\u4E00-\u9FA5]+$/,message: '用户名只能为中文'}
        ],
        mobile: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ],
        bankCardNo: [
        { required: true, message: '请输入银行卡号',min: 12, max: 20, trigger: 'blur', },
        ],
        idNo: [
        { required: true, message: '请输入身份证号', trigger: 'blur' },
        { min: 15, max: 18, message: '请如实填写身份证号', trigger: 'blur' },
              {
                   required: true,
                   pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                   message: '请输入正确的身份证号码',
                   trigger: 'blur'
              }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
       
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    },
    cityList () {
      let arr = []
      // this.$set(this.dataForm,'shi','')
      this.city.forEach(item =>{
        if(item.name == this.dataForm.sheng){
          console.log(item)
         arr = item.area
        }
      })
      return arr
    },
  },
  methods: {
    changeAmount(){
      this.dataForm.loanApplyList[0].loanAmount = this.dataForm.loanApplyList[0].loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[0]
    },
    selectCity(){
      this.dataForm.loanApplyList[0].signPlace = this.dataForm.loanSheng+'|'+this.dataForm.loanShi+'|'+this.dataForm.loanQu
      console.log(555,this.dataForm.loanApplyList[0].signPlace);
    },
    qx(){
      this.$emit('dataFormFS')
      this.dataForm = {
                  "address": "",
                  "areaCode": "",
                  "cityCode": "",
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  loanType:'',
                  loanDetailed:'',
                  repaymentTypeCode:'',
                  mortgageAddress:'',
                  buildArea:'',
                  useArea:'',
                  mortgageNo:'',
                  price:'0',
                  signAddress:'',
                  mortgageAtt:'',
                  sheng:'',
                  shi:'',
                  "loanApplyList": [
                {
                  "bankCardNo": "",
                   bankName:'',
                   "disputeMode": "",
                   "arbitrationCommittee": "",
                  "createTime": "",
                  "custId": '',
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "postScript":'',
                  "loanAmount": '',
                  "loanRate": '',
                  "loanUsage": "",
                  "overdueRate": '',
                  "productCode": "",
                }
              ],
              "mobile": "",
              "provinceCode": "",
              "registerAddress": "",
              "registerAreaCode": "",
              "registerCityCode": "",
              "registerProvinceCode": "",
              "relationList": [
              ],
              "commonMortgage":[]
	                  }
      this.dialogVisible = false
    },
    getFormData(){
     
    //成功回调函数停止加载
   

      this.$http.get(`/loan/tloanapply/${this.infoid.id}`).then( r => {
       
        let data = r.data.data 
        let loanApplyList = JSON.parse(JSON.stringify(this.dataForm.loanApplyList))
        this.dataForm.loanApplyList = loanApplyList
        this.dataForm.loanApplyList[0].initPeriod = String(this.dataForm.loanApplyList[0].initPeriod)
        let custName = data.custName
        let mobile = data.mobile
        let idNo = data.idNo
        this.dataForm.email = data.email
        this.dataForm.borrowerType = data.borrowerType
        this.dataForm.bankCardNo = data.bankCardNo
        this.dataForm.bankName = data.bankName
        this.dataForm.bankProName = data.bankProName
        this.dataForm.bankCityName = data.bankCityName
        this.dataForm.brabankName = data.brabankName
        let address = data.address
        let cityList = []
        if(data.signPlace){
          cityList = data.signPlace.split('|')
          console.log(12,cityList);
        }
        let cityArr = []
        if(data.mortgageEntity){
          console.log('00000')
           cityArr =  data.mortgageEntity.signAddress.split('|') 
        }
        if(data.productCode == '2'){
          this.isShowPledge = true
        }else{
          this.isShowPledge = false
        }

        this.dataForm = {
          ...this.dataForm,
          mobile,
          idNo,
          custName,
          address,
          id:'',
          loanType: data.loanType,
          loanDetailed: data.loanDetailed,
          repaymentTypeCode: data.repaymentTypeCode,
          // mortgageAddress: data.mortgageAddress,
          // buildArea: data.buildArea,
          // useArea: data.useArea,
          // mortgageNo: data.mortgageNo,
          // price: data.price,
          // signAddress: data.signAddress,
          // mortgageAtt: data.signAddress,
          ...data.mortgageEntity,
          sheng:cityArr[0],
          shi:cityArr[1],
          loanSheng:cityList[0],
          loanShi:cityList[1],
          loanQu:cityList[2],
          relationList:data.relationList?data.relationList:[],
          commonMortgage:data.commonMortgage?data.commonMortgage:[],
          loanApplyList:[{
            productCode:data.productCode,
            loanUsage:data.loanUsage,
            initPeriod:[data.loanStartTime,data.loanEndTime],
            loanRate:data.loanRate,
            interestTypeCode:data.repaymentMode,
            postScript:data.postScript,
            createTime:data.createTime,
            bankCardNo:data.bankCardNo,
            bankName:data.bankName,
            disputeMode:data.disputeMode,
            arbitrationCommittee:data.arbitrationCommittee,
            loanAmount:data.loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            overdueRate:data.overdueRate

          }]

        } 
     
        this.dialogVisible = true
      })
    
    },
    // 删除共借人
    del(mobile){
      this.dataForm.relationList = this.dataForm.relationList.filter(item => item.mobile != mobile)
    },
     // 添加共借人
    submitForm(relationList) {
        this.$refs[relationList].validate((valid) => {
          if (valid) {
            
                this.gjr = false
                // 添加成功刷新数据
                 this.dataForm.relationList.push(JSON.parse(JSON.stringify(this.relationList)))
                 this.relationList = {
                      "addr": "",
                      "email": "",
                      "idNo": "",
                      "mobile": "",
                      "name": "",
                    }
                 this.$message({
                  message: '修改成功',
                  type: 'success'
                })
           
          } else {
          
            return false;
          }
        });
        
      },
     
    echo(r){
      this.dataForm.borrowType  = r == '抵押类' ? 'b n j k' : 'bndy'
    },
   
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    handleClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/loan/tloanapply/${this.dataForm.id}`).then(({ data: res }) => {
        // if (res.code !== 0) {
        //   return this.$message.error(res.msg)
        // }
        // this.dataForm = {
        //   ...this.dataForm,
        //   ...res.data
        // }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
     
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.isButton = true
          console.log(this.infoid)
          let dataForm = {
                  "id":JSON.parse(JSON.stringify(this.infoid.id)),
                  "custId": JSON.parse(JSON.stringify(this.infoid.custId)),
                  "productCode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].productCode)),
                  "loanUsage":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanUsage)),
                  "loanRate":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanRate)),
                  "interestTypeCode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].interestTypeCode)),
                  "postScript":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].postScript)),
                  "loanAmount":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].loanAmount))  ,
                  "overdueRate":JSON.parse(JSON.stringify( this.dataForm.loanApplyList[0].overdueRate)) ,
                  "loanStartTime":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].initPeriod[0]))  ,
                  "loanEndTime":JSON.parse(JSON.stringify( this.dataForm.loanApplyList[0].initPeriod[1])),
                  "contractSignTime":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].createTime)),
                  "bankCardNo":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].bankCardNo)),
                  "bankName":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].bankName))  ,
                  "arbitrationCommittee":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].arbitrationCommittee)),
                  "disputeMode":JSON.parse(JSON.stringify(this.dataForm.loanApplyList[0].disputeMode)),
                  "relationList":JSON.parse(JSON.stringify(this.dataForm.relationList)) 
              }
              
          this.$http.put('/loan/tloanapply',dataForm).then(r => {
             
            if(r.data.code == 0){
              this.$message({
                  message: '修改成功',
                  type: 'success',
                })
               this.$emit('signedFS')
                this.dataForm = {
                  "address": "",
                  "areaCode": "",
                  "cityCode": "",
                  "custName": "",
                  "id": '',
                  "idNo": "",
                  "loanApplyList": [
                {
                  "bankCardNo": "",
                   bankName:'',
                   "arbitrationCommittee":"",
                   "disputeMode": "",
                  "createTime": "",
                  "custId": '',
                  "initPeriod": '',
                  "interestTypeCode": "",
                  "postScript":"",
                  "loanAmount": '',
                  "loanRate": '',
                  "loanUsage": "",
                  "overdueRate": '',
                  "productCode": "",
                }
              ],
          
              "mobile": "",
              "provinceCode": "",
              "registerAddress": "",
              "registerAreaCode": "",
              "registerCityCode": "",
              "registerProvinceCode": "",
              "relationList": [
              ],
              "commonMortgage":[],
	                  }
                this.dialogVisible = false
                this.isButton = false
            }else{
              this.isButton = false
              this.$message({
                message:r.data.msg,
                type:'warning'
              })
            }
            
          })
          console.log('成功')
        }else{
          console.log('失败')
        }
       
      })
    }, 1000, { 'leading': true, 'trailing': false })

    
  }
}


</script>

<style lang="scss" scoped>
  @import '../../../assets/css/passWord.css';
 .tj{
  border: 1px solid #ccc;
 }
//  .gjr{
//   border: 1px solid red;
//  }
 .ht{
  display: flex;
  justify-content: space-between;
 }
 .h3{
  margin: 20px 0;
 }
 .styW{
  height: 42px;
  width: 350px !important;
 }
 .sandh{
  width: 100%;
}
.styW1{
  width: 500px;
 }
 .font-max{
  display: inline-block;
  font-size: 19px;
  position: relative;
  top: 3px;
 }
 .arbitration{
  display: flex;
  .ar_input{
    width: 140px;
    margin-right: 4px;
  }
}
.selectArea{
  color: red;
  position: absolute;
  left: -8px;
  top: 0px;
}
</style>
